import React from "react";
import "./privacyPolicy.css";
const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <h5>Privacy Policy:</h5>
      <h6>INTRODUCTION</h6>
      <span>
        ProTowCall Ltd. (collectively, “ProTowCall”, “we”, “us” or “our”) are
        committed to protecting the privacy and conﬁdentiality of personal
        information in our possession. This Privacy Policy explains how we
        collect, use and disclose personal information that you provide to us
        through the ProTowCall website located at https://Protowcall.ca (the
        “Website”) together with the mobile version of the website and the
        mobile application (the “App”, and collectively, the Website, mobile
        version and App are the “Service”). ProTowCall is a technology platform
        that enables Registered Users of our Service to obtain roadside
        assistance from independent third-party providers of such services who
        are under agreement with us (“Third Party Service Providers”). Unless
        otherwise deﬁned herein, all deﬁned terms have the same meaning as set
        out in the Terms of Service.
      </span>
      <br />
      <br />
      <span>
        By accessing or using the Service, you signify your acceptance of this
        Privacy Policy and consent to be bound by its terms. You can withdraw
        your consent at any time by contacting our privacy ofﬁcer as directed
        below, however, if you choose to withdraw your consent, we may not be
        able to provide you with the services or communications that are
        available through the Service.
      </span>
      <p>CHANGES TO THIS PRIVACY POLICY</p>
      <span>
        We reserve the right, at our discretion, to amend this Privacy Policy at
        any time without prior individual notice. The date on which this Privacy
        Policy was last amended is shown at the top of this policy. You are
        responsible for verifying whether any amendments have been made and
        therefore we ask that you periodically check the date and review this
        Privacy Policy for the latest information on our privacy practices. If
        you object to any amendments, please stop using the Service, otherwise
        your continued use will be taken as your consent to such amendments.
      </span>
      <p>WHERE THIS PRIVACY POLICY IS EFFECTIVE</p>
      <span>
        ProTowCall is subject to the Personal Information Protection and
        Electronic Documents Act (Canada) and applicable Canadian provincial
        privacy legislation. Privacy laws vary by jurisdiction. You acknowledge
        and agree that access to the Service that are available through the
        Service are provided via the Internet and that your information,
        including personal information, may be transferred across national
        borders and stored or processed in accordance with the terms and
        conditions of this Privacy Policy.
      </span>
      <br />
      <br />
      <span>
        This Privacy Policy has a limited scope and application. Consequently,
        the rights and obligations contained in this Privacy Policy may not be
        consistent with privacy requirements for all jurisdictions.
      </span>
      <p>WHAT IS PERSONAL INFORMATION?</p>
      <span>
        For the purposes of this Privacy Policy, personal information is any
        information about or that identiﬁes a speciﬁc individual, and under
        certain laws that may or may not be applicable to you, identiﬁes a
        speciﬁc household or device.
      </span>
      <p>THE PERSONAL INFORMATION THAT WE COLLECT</p>
      <span>
        We collect and maintain different types of personal information in
        respect of the individuals with whom we interact. This personal
        information may include, but is not limited to, the personal information
        that is described in the sections below.
      </span>
      <p>Personal information that you provide to us as a Registered User</p>
      <span>
        personal contact information for yourself that is used to create an
        Account with us, such as your name, email address, phone number, home
        address and a photograph of yourself. Please note that we will use your
        contact information to send you a SMS veriﬁcation in connection with the
        creation of your Account; information about your vehicle, including the
        year, make, and model of the vehicle, an image of the vehicle, and your
        licence plate number (the “Vehicle Information”); personal contact
        information for a minor for whom you are a parent or legal guardian and
        are creating a Minor Subaccount (as further described in our Terms of
        Service), such as the minors name, email address, phone number, home
        address and a photograph of the minor. Please note that we will use the
        minor’s contact information to send the minor a SMS veriﬁcation in
        connection with the creation of the Minor Subaccount; location in
        connection with your use of the Service. For example, we use your
        location information to determine your location when you request
        assistance from a Third Party Service Provider through the Service. You
        can enter this information manually or allow us to collect this
        information through the settings in your App; transaction information in
        connection with your use of the Service, which includes the type of
        service requested, your Responses to any prompts, the date and time the
        service was provided, the information of the Third Party Service
        Provider you were matched with, the amount charged and the payment
        method; and personal information that is contained in any customer
        service inquiry, User Content, in-App communications between you and a
        Third Party Service Provider, or other communication, including your
        rating or review from the Third Party Service Provider. You may use your
        PayPal account or credit card to use the Service. When you create an
        Account, you will be directed to the Braintree, a division of PayPal,
        Inc., website to input your credit card information. Please see section
        on PAYMENT PROCESSING for further details. We are provided with
        conﬁrmation from our Payment Processors (as deﬁned below) when your
        transaction has been completed.
      </span>
      <p>
        Personal information that you provide to us as a Third Party Service
        Provider
      </p>
      <span>
        personal contact information required to register an account as a Third
        Party Service Provider, such as your name, email address, phone number,
        and home address, date of birth, signature, and a photograph of
        yourself; business contact information, such as your title, business
        address, email address, work eligibility, and details relating to your
        employment; information relating to your licenses (e.g., driver’s
        license), vehicle insurance, permits, qualiﬁcations, education,
        credentials and other experience as required to determine your
        suitability to provide Vehicle Services, as more particularly described
        in the Terms; Vehicle Information (as deﬁned above); payment and banking
        information, including your account number, institution number, transit
        number and the email address associated with your bank account for
        e-transfers; location information in connection with your use of the
        Service, which is used to track your proximity to how close they are to
        a Registered User, the distance until they arrive to perform the Vehicle
        Services and how long the Vehicle Services are taking; transaction
        information, including the date and time the service was provided, the
        distance travelled, the information of the Registered User you were
        matched with and the amount charged to the Registered User. We will also
        collect information about the rating or review from the Registered User;
        and personal information that is contained in any customer service
        inquiry, User Content, in-App communications between you and a
        Registered User, or other communication, including your rating or review
        from the Third Party Service Provider. Please note that we may request
        that you provide more than one piece of identiﬁcation for the purpose of
        completing a background check. When you create an Account as a Third
        Party Service Provider, you will be sent a link to complete your
        background check, as required in connection with Account creation.
      </span>
      <p>Personal Information that we Receive from Third Parties</p>
      <span>
        As a general rule, we collect personal information directly from you. In
        most other circumstances where the personal information we collect about
        you is held by a third party, we will take reasonable steps to ensure
        that such third party has obtained your permission to disclose your
        information to us (such permission may be given directly by you, or
        implied from your actions). From time to time, we may utilize the
        services of third- parties and may also receive personal information
        collected by those third-parties in the course of the performance of
        their services for us or otherwise.
      </span>
      <p>OTHER INFORMATION THAT WE COLLECT</p>
      <p>For Registered Users, Third Party Service Providers and Visitors</p>
      <li>Technical and Usage Information</li>

      <span>
        {" "}
        When you visit the Website, web servers automatically collect certain
        information about your visit to a website, including your Internet
        Protocol (“IP”) address. IP addresses are unique numbers assigned by
        Internet Service Providers (“ISP”) to all devices used to access the
        Internet. Web servers automatically log the IP addresses of visitors to
        their sites. The IP address, on its own, may not identify you, but can
        do so when combined with other data automatically collected when you
        request a web page, such as the name of the page you visited and the
        date and time of your visit.
      </span>
      <span>
        When you visit the Website, we may collect technical information, which
        may include the address of the website that you visited before visiting
        the Website, the pages of the Website that you visit, the browser you
        used to view the Website, the search terms you entered on the Website,
        and other such technical data.
      </span>

      <span>
        If you have downloaded and use the App, we also collect access dates and
        times, App features used, App crashes and other system activity.
      </span>
      <li>Cookies</li>
      <span>
        We may also use cookies. Cookies are small ﬁles that a site or its
        service provider transfers to your computer’s hard drive through your
        web browser (if you allow) that enables the sites or service providers
        systems to recognize your browser and capture and remember certain
        information. We use the following Cookies:
      </span>
      <li>Functionality Cookies:</li>
      <span>
        These cookies allow a website to remember the choices a user has made in
        the past, like what language the user prefers or what the user’s name
        and password are so that the user can automatically log in.
      </span>
      <li>Analytical Cookies:</li>
      <span>
        These cookies allow us to recognize and count the number of visitors to
        our Service and see how visitors move around our Website and Application
        when they are using it. This helps us improve the way our Service works,
        for example, by ensuring users are ﬁnding what they are looking for
        easily.
      </span>
      <br />
      <br />
      <span>
        We use cookies to help us remember and process the items in your
        shopping cart, understand and save your preferences for future visits
        and compile aggregate data about site trafﬁc and site interaction so
        that we can offer better site experiences and tools in the future. We
        may contract with third-party service providers to assist us in better
        understanding our site visitors. These service providers are not
        permitted to use the information collected on our behalf except to help
        us conduct and improve our business.
      </span>
      <br />
      <br />
      <span>
        If you prefer, you can choose to have your computer warn you each time a
        cookie is being sent, or you can choose to turn off all cookies via your
        browser settings. Disabling cookies when you visit our Website will have
        no discernible impact on your browsing experience. Please consult your
        browser’s Help Menu for instructions.
      </span>
      <br />
      <br />
      <span>
        Like most websites, if you turn your cookies off, some of our services
        may not function properly.
      </span>
      <li>Device Information.</li>
      <span>
        We collect information about the device(s) you use to access our
        Service, including the hardware models, device IP address, operating
        systems and versions, software, ﬁle names and versions, preferred
        languages, unique device identiﬁers, advertising identiﬁers, serial
        numbers, device motion information, and mobile network information.
      </span>
      <p>PURPOSES FOR COLLECTION AND USE OF YOUR INFORMATION</p>
      <span>
        We may collect and use personal information for the purposes identiﬁed
        at the time of collection, as otherwise permitted or required by
        applicable law, or for any of the following purposes:
      </span>
      <li>
        to establish, maintain and manage our relationship with you so that we
        can provide you with the Service and/or access to our Website;
      </li>
      <li>
        to provide you with the services you have requested through the Service
        and to facilitate your receipt and/or provision of services as a
        Registered User or Third Party Service Provider;
      </li>
      <li>
        to understand your preferences and tailor communications and services to
        you and to send you information about PROTOWCALL and its partners;
      </li>
      <li>to match Registered Users with Third Party Service Providers;</li>
      <li>
        to screen Third Party Service Providers to help ensure the safety of
        Registered Users, including by conducting background;
      </li>
      <li>
        to enable Vehicle Services or other services, including to suggest tow
        truck drivers and to offer nearby service providers in the event the
        Registered User needs additional Vehicle Services from a mechanic;
      </li>
      <li>to track the progress of the Vehicle Services;</li>
      <li>to comply with our legal obligations and regulatory requirements;</li>
      <li>to develop and manage our business and operations;</li>
      <li>
        for billing, accounting and debt collection services relating to the
        Service;
      </li>
      <li>to facilitate payment for the use of the Service;</li>
      <li>to respond to your questions and concerns;</li>
      <li>
        to detect and protect us and you from error, negligence, breach of
        contract, fraud, theft or other illegal activity, and which may include
        sharing personal information with our insurers;
      </li>
      <li>
        to create aggregate information for analytics purposes, including to
        analyze the success, effectiveness, usability or popularity of the
        Service or website;
      </li>
      <li>to resolve disputes or misunderstandings between users;</li>
      <li>for internal, external and regulatory audit purposes;</li>
      <li>
        to correct technical problems and malfunctions related to the Service;
        and
      </li>
      <li>any other reasonable purpose to which you consent.</li>
      <span>
        By consenting to our collection, use and disclosure of your personal
        information through our Service you allow us to fulﬁll the purposes for
        which we collect your personal information. When we collect your
        information for research and development purposes, we ensure that any
        information used for our analysis and reports will be de-identiﬁed and
        aggregated in a manner that will not identify you.
      </span>
      <p>HOW DO WE USE YOUR PERSONAL INFORMATION?</p>
      <span>We may use your personal information:</span>
      <li>
        as permitted or required by applicable law or regulatory requirements;
      </li>
      <li>for the purposes described in this Privacy Policy; and</li>
      <li>
        for any additional purposes for which we have obtained your consent to
        use your personal information.
      </li>
      <span>
        We may use your personal information without your knowledge or consent
        where we are permitted or required by applicable law or regulatory
        requirements to do so.
      </span>
      <p>The ways we communicate with you</p>
      <span>
        We will collect your express or implied consent prior to sending you any
        commercial electronic messages, unless an exception to obtaining your
        opt-in consent applies under Canada’s Anti-Spam Legislation (CASL). You
        will have the opportunity to opt-out of receiving commercial electronic
        messages at any time. In connection with your use of the Service, we may
        send you transaction and marketing communications, as described below.
      </span>
      <p>Transactional Communications</p>
      <span>
        We provide notiﬁcations for certain activities relating to your use of
        our Services. Examples of transaction communications we may send include
        sending you emails and SMS messages when you create an account,
        set/change your password, request a service from a Third Party Service
        Provider, and complete a transaction through the Service. While you may
        unsubscribe from marketing communications that are sent to you (as
        described below), you will continue to receive transactional messages
        from us relating to your use of the Service and your Account.
      </span>
      <p>Marketing Communications</p>
      <span>
        With your consent, we may send you news and marketing communications
        regarding our products and services that are available through the
        Service and that we believe may be of interest to you. If at any time
        you would like to unsubscribe from receiving future marketing emails,
        please contact us at [insert email address], and we will promptly remove
        you from our marketing correspondence lists. You can also opt-out of
        receiving marketing communications through the unsubscribe links
        provided in the marketing messages we send to you.
      </span>
      <p>HOW YOUR INFORMATION IS DISCLOSED OR SHARED</p>
      <p>How you may share your information</p>
      <span>
        As described above, certain features of the Service allow Registered
        Users to make some information available to others. Please think
        carefully about what you share with others.
      </span>
      <p>How we share your information</p>
      <span>
        If you are a Registered User, we will share certain information to Third
        Party Service Providers who use the Service when you are requesting a
        service through the Service. We will disclose your location and your
        rating to potential Third Party Service Providers so that we may match
        you with a Third Party Service Provider who is in close proximity. We
        will also disclose your name, your vehicle information and your photo,
        if uploaded, to the Third Party Service Provider with whom you have been
        matched. The Third Party Service Provider will also be able to see your
        rating and any reviews or comments left by other Third Party Service
        Providers with whom you have interacted.
      </span>
      <br />
      <br />
      <span>
        If you are a Third Party Service Provider, we will share information
        with the Registered User, including your name, your vehicle information,
        the image of your vehicle, and your photo, if uploaded. The Registered
        User will also be able to see your rating and any reviews or comments
        left by other Registered Users with whom you have interacted.
      </span>
      <br />
      <br />
      <span>
        We may disclose your personal information to our afﬁliates and our
        respective employees, contractors, consultants, service providers and
        other parties who require such information to assist us with managing
        our relationship with you, including third parties that provide services
        to us or on our behalf.
      </span>
      <br />
      <br />
      <span>
        We may also disclose personal information of Registered Users or Third
        Party Service Providers in the following circumstances:
      </span>
      <br />
      <br />
      <li>as described in this Privacy Policy;</li>
      <li>
        to investigate suspected fraud, harassment or other violations of any
        law, rule or regulation, or the policies for the Service;
      </li>
      <li>
        to meet or comply with any applicable law, regulation, legal process,
        audit or enforceable request from a government agency or regulatory
        body;
      </li>
      <li>
        in connection with a bankruptcy proceeding or the sale, merger or change
        of control of ProTowCall;
      </li>
      <li>
        in the event of a merger, acquisition sale or reorganization, or the
        potential thereof, we may disclose information about you to the extent
        the personal information is necessary to carry on the business or
        activity that was the object of the transaction. In the event of a
        completed transaction, notice will be given to affected users; and
      </li>
      <li>
        for any additional purpose for which we have obtained your consent to
        disclose your personal information.
      </li>
      <span>
        We do not sell or rent client lists or personal information to others.
      </span>
      <br />
      <br />
      <span>
        We may retain third party service providers, such as cloud storage
        services discussed below to help us provide the Service to you. We may
        need to transfer your personal information to these third party service
        providers. We use contractual means to ensure these providers provide
        safeguards that are comparable to our own while your personal
        information is in their possession. These service providers make no
        independent use of your personal information.{" "}
      </span>
      <br />
      <br />
      <span>
        We may engage third party external servers as well as other external
        services, including cloud services and cloud compatible servers.We may
        use third party service providers or cloud hosting located outside
        Canada. Since we may share your personal information with third parties,
        as described in this Privacy Policy, your personal information may be
        collected, used, processed, stored or disclosed outside of your
        jurisdiction of residence, including in the United States and other
        countries whose law may not provide for the same level of data
        protection as where you live. As such, your personal information may
        potentially be accessible to law enforcement and national security
        authorities of another jurisdiction which could impact on your rights,
        such as your right to an effective legal remedy.
      </span>
      <span>
        By using the Service, you understand and consent to our disclosure of
        your information outside the jurisdiction in which you live. You
        understand and consent that if your information is processed in a
        foreign country, it may be subject to foreign laws and accessible to law
        enforcement and national security authorities within that jurisdiction.
        You also acknowledge that we may disclose your information without your
        consent where permitted by law or regulatory requirements.
      </span>
      <p>PAYMENT PROCESSING FOR REGISTERED USERS</p>
      <br />
      <br />
      <span>
        We use (i) Braintree, a division of PayPal, Inc., (ii) Apple Pay; and
        (iii) Google Pay as a third party payment processors (collectively, the
        “Payment Processors”), to process payments made in connection with the
        Service. The Payment Processors will collect and store payment
        information and other personal information necessary to process your
        payment. When you make a purchase using the Payment Processors, you are
        subject to their respective Privacy Policy and Terms of Use which we
        encourage you to read. We are not responsible for how the Payment
        Processors manage your payment and personal information to process your
        payment. The privacy policies of each Payment Processor can be found
        here: (i) Apple Pay; (ii) Google Pay; and (iii) Braintree /PayPal.
      </span>
      <p>LINKS TO OTHER WEBSITES</p>
      <span>
        As described in the Terms of Service, our Website and/or Service may
        contain links to other sites. This Privacy Policy applies only to
        personal information that we collect, use and disclose. We are not
        responsible or liable for the privacy practices of third parties, and we
        strongly recommend that you review a third party’s privacy policy before
        disclosing any personal information to the third party.
      </span>
      <p>RETENTION AND DESTRUCTION OF PERSONAL INFORMATION</p>

      <span>
        {" "}
        We will store personal information collected via the Service only as
        long as is necessary for the purposes for which the information was
        collected. Thereafter, we will keep your information for a reasonable
        time in accordance with our standard procedures to comply with our legal
        obligations, to resolve disputes, prevent fraud and abuse and to enforce
        our agreements, or as necessary for archival/audit purposes.
      </span>
      <br />
      <br />
      <span>
        Even if we delete some or all of your personal information, we may
        continue to create, retain or use aggregated or anonymized data.
      </span>
      <p>SAFEGUARDING PERSONAL INFORMATION</p>
      <span>
        We endeavour to employ commercially reasonable physical, technical,
        electronic and procedural safeguards that are appropriate based on the
        sensitivity of the personal information in question. These safeguards
        are designed to protect personal information under our control against
        unauthorized access, use, loss, disclosure, copying, modiﬁcation,
        disposal or destruction.
      </span>
      <br />
      <br />
      <span>
        Please note that by submitting User Content (as deﬁned in the Terms of
        Service) that includes personal information on or through the Service,
        you are choosing to share your personal information with other users
        (i.e., the public), including as more particularly described in this
        Privacy Policy and the Terms of Service.
      </span>
      <p>ELECTRONIC COMMUNICATIONS</p>
      <span>
        With your express consent, we may send you promotional emails. At any
        time, you may opt out of receiving such messages by following the
        unsubscribe instructions in each email. Please note that even if you opt
        out of promotional emails, we will continue to send you important
        account-related information.
      </span>
      <p>KEEPING INFORMATION ACCURATE / ACCESS AND CORRECTION</p>
      <span>
        {" "}
        It is important that your personal information held by us is accurate
        and complete so that we can give you better service. We ask that you
        keep us informed of any changes, such as a change of address, telephone
        number or email address.
      </span>
      <span>
        You have the right to access and correct the information we have about
        you after we have received your written request and authenticated your
        identity. Subject to legal restrictions or speciﬁc rights of refusal, we
        will inform you of the existence, use and disclosure of personal
        information relating to you and give you access to that information.
      </span>
      <span>
        We may charge a reasonable fee for providing information in response to
        an access request, and, upon request, we will provide an estimate of any
        such fee upon receiving a request to access information.
      </span>
      <span>
        Despite our efforts, errors sometimes do occur. If you identify any
        personal information that is out-of-date, incorrect or incomplete, let
        us know. If we agree, we will make the corrections and will make
        reasonable efforts to communicate these changes to other parties with
        whom we shared the information.
      </span>
      <p>WITHDRAWAL OF CONSENT</p>
      <span>
        WITHDRAWAL OF CONSENT At any time, you may terminate your account.
        Please see our Terms of Service for more details on how to close your
        account.
      </span>
      <br />
      <br />
      <span>
        Should you choose to close your account, we will be unable to provide or
        to continue to provide, the Service.
      </span>
      <h5>CHILDREN’S PRIVACY</h5>
      <span>
        You must be at least 18 years of age to become a Registered User. You
        must be at least 21 years of age to become a Third Party Service
        Provider.
      </span>
      <br />
      <br />
      <span>
        Please review the Terms of Use for requirements to create a Minor
        Subaccount. We do not knowingly collect personal information directly
        from anyone under the age of 18. Information from Minors must be
        provided by his or her parent or legal guardian.
      </span>
      <br />
      <br />
      <span>
        If you are a parent or guardian and you are aware that your child has
        provided us with personal information, please contact us. If we become
        aware that we have collected personal information from children, we will
        take reasonable steps to locate and remove that information from our
        servers and records.
      </span>
      <p>PRIVACY CONCERNS</p>
      <span>
        If you have any questions and concerns relating to our handling of your
        personal information, please direct them to our privacy ofﬁcer listed
        below. We may need to ask you for personal information to verify your
        identity.
      </span>
      <span>E-mail: Privacy@protowcall.com</span>
      <span>
        If, having shared your concerns with us, you are not satisﬁed with our
        answers, you may ﬁle a complaint with a privacy regulator, such as the
        Ofﬁce of the Privacy Commissioner of Canada by mail at 30 Victoria
        Street Gatineau, Quebec K1A 1H3 or by calling 1 800 282 1376.
      </span>
      <span>
        **If you choose to communicate with us via email, please be aware that
        email is not a 100% secure medium for sending any personal or
        conﬁdential information to us. **
      </span>
    </div>
  );
};

export default PrivacyPolicy;
